import { render, staticRenderFns } from "./PerformanceReviewDetails.vue?vue&type=template&id=0a743124&scoped=true"
import script from "./PerformanceReviewDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReviewDetails.vue?vue&type=style&index=0&id=0a743124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a743124",
  null
  
)

export default component.exports